<template>
  <span class="kpi-process-flow-help">
    <feather-icon
      icon="HelpCircleIcon"
      size="18"
      class="kpi-process-flow-help-icon"
      @click="showFlowImage = true"
    />
    <b-modal
      v-model="showFlowImage"
      title="KPI Process Flow"
      hide-footer
      centered
      size="xl"
      modal-class="kpi-flow-image-modal"
      content-class="kpi-flow-image-modal-content"
      body-class="kpi-flow-image-modal-body"
    >
      <img
        :src="kpiProcessFlowImage"
        alt="KPI Process Flow"
        class="kpi-process-flow-modal-image"
      />
    </b-modal>
  </span>
</template>

<script>
export default {
  data() {
    return {
      kpiProcessFlowImage: require('@/assets/images/KPI_Process_Flow.jpeg'),
      showFlowImage: false,
    };
  },
};
</script>

<style scoped>
.kpi-process-flow-help {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}

.kpi-process-flow-help-icon {
  color: #40aee5;
  cursor: pointer;
}

.kpi-process-flow-modal-image {
  width: 100%;
  height: auto;
  max-height: calc(85vh - 5rem);
  object-fit: contain;
  display: block;
}
</style>

<style>
.kpi-flow-image-modal .modal-dialog {
  max-width: 92vw;
  width: 92vw;
  margin: 1.75rem auto;
}

.kpi-flow-image-modal-content {
  max-height: 88vh;
}

.kpi-flow-image-modal-body {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem 1rem;
  overflow: auto;
}
</style>
